import React from 'react';
import { useTranslation } from 'react-i18next';

const NewsHasAttachments = ({ value }) => {
    const { t } = useTranslation();

    const hasFiles = Array.isArray(value) && value.length > 0;

    return <span>{hasFiles ? t('news.hasAttachments') : t('news.noAttachments')}</span>;
};

export default NewsHasAttachments;
